import styled, { keyframes } from "styled-components";

import { fontSizes } from "../../../shared/styles/typography";
import { pageRoot } from "../../../styles/pageRoot";

const shimmer = keyframes`
  0% { background-position: -468px 0; }
  100% { background-position: 468px 0; }
`;

export const SkeletonBox = styled.div`
  width: 100%;
  height: 100%;
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  animation: ${shimmer} 1.5s linear infinite forwards;
`;

export const PageContainer = styled.div`
  ${pageRoot}
  background: #f8fafc;
  align-items: center;
  padding-bottom: 100px;
`;

export const MobileWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`;

export const HeaderMobile = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: #f8fafc;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const HeaderTitle = styled.h1`
  font-size: ${fontSizes.xl}px;
  font-weight: var(--font-weight-bold);
  color: #0f172a;
  text-transform: uppercase;
`;

export const BackBtn = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: #0f172a;
  display: flex;
  align-items: center;
`;

export const NotifBtn = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: #0f172a;
  display: flex;
  align-items: center;
`;

export const TagRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  margin-bottom: 24px;
`;

export const LetterTag = styled.div`
  background: #4614bb;
  color: white;
  padding: 8px 16px;
  border-radius: 24px;
  font-size: ${fontSizes.sm}px;
  font-weight: var(--font-weight-bold);
  border: 2px solid rgba(255, 255, 255, 0.2);
`;

export const HeartBtnBox = styled.button<{ $active?: boolean }>`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: white;
  border: 2px solid
    ${(props) => (props.$active ? "#EF4444" : "rgba(0, 0, 0, 0.05)")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${(props) => (props.$active ? "#EF4444" : "#64748b")};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const ImageCard = styled.div`
  margin: 0 24px 24px;
  background: white;
  border-radius: 20px;
  padding: 6px;
  box-shadow: 0 8px 24px rgba(109, 61, 216, 0.15);
  border: 2px solid #5f33e1;
  aspect-ratio: 1;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }
`;

export const VideoCard = styled.div`
  margin: 0 24px 24px;
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 24px;
  overflow: hidden;
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
`;

export const VideoPlayerFrame = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  max-height: min(70vh, 560px);
  background: #0f172a;
  display: flex;
  align-items: center;
  justify-content: center;

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    display: block;
    background: #0f172a;
  }
`;

export const MaximizeBtn = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(0, 0, 0, 0.45);
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 5;
  backdrop-filter: blur(4px);
`;

export const SpeedControlBox = styled.div`
  background: #4a4a4a;
  margin: 12px 16px 16px;
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
`;

export const SpeedTitle = styled.div`
  color: white;
  font-size: ${fontSizes.sm}px;
  font-weight: 600;
  text-align: center;
`;

export const SpeedButtonsRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const SpeedBtn = styled.button<{ $active?: boolean }>`
  flex: 1;
  background: ${(props) => (props.$active ? "#4614bb" : "white")};
  border: 1px solid ${(props) => (props.$active ? "#4614bb" : "#e2e8f0")};
  color: ${(props) => (props.$active ? "white" : "#64748b")};
  border-radius: 12px;
  padding: 10px 4px;
  font-size: ${fontSizes.sm}px;
  font-weight: var(--font-weight-semibold);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
`;

export const MeaningSection = styled.div`
  padding: 0 24px;
  margin-bottom: 32px;
`;

export const MeaningHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const InfoIconBox = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4614bb;
`;

export const MeaningTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MeaningTitle = styled.h3`
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-bold);
  color: #0f172a;
  margin: 0;
`;

export const MeaningSubtitle = styled.span`
  font-size: ${fontSizes.sm}px;
  color: #64748b;
`;

export const MeaningText = styled.p`
  font-size: ${fontSizes.base}px;
  color: #1e293b;
  line-height: 1.6;
`;

export const ActionButtonsGroup = styled.div`
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ActionRowBtn = styled.button`
  width: 100%;
  background: white;
  border-radius: 20px;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    transform: translateY(-2px);
  }

  .icon-box {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: #f1f5f9;
    color: #4614bb;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .text-box {
    text-align: left;
    display: flex;
    flex-direction: column;
  }

  h4 {
    font-size: ${fontSizes.base}px;
    font-weight: var(--font-weight-bold);
    color: #1e293b;
    margin: 0 0 4px;
  }

  span {
    font-size: ${fontSizes.sm}px;
    color: #94a3b8;
  }
`;
